import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import { useGetStrategyDashboardCostQuery } from "src/store/api/generatedApi";
import { buildSeriesCollection } from "./utils";
import { CostTabData } from "../types";
import { useMemo } from "react";

export const useStrategyDashboardCost = (
  start?: string,
  end?: string
): Loaded<CostTabData> => {
  const tenantName = useTenant();
  const loadedRawData = loadedEndpoint(
    useGetStrategyDashboardCostQuery({
      tenantName,
      timeAggregation: "monthly",
      start,
      end,
    })
  );

  const processedData = useMemo(() => {
    if (loadedRawData.status === "success") {
      return {
        status: "success" as const,
        data: buildSeriesCollection(loadedRawData.data.series_collection),
        fetching: loadedRawData.fetching,
      };
    }
    return loadedRawData;
  }, [loadedRawData]);

  return processedData;
};
